<template>
  <section
    class="ls-note"
    aria-label="Note for the brand"
  >
    <div class="ls-note__inner">
      <ls-feedback-text
        :label="`Anything else for ${brandName}?`"
        :value="note"
        :limit="limit"
        :status="status"
        :rows="4"
        @input="text => $emit('input', text)"
        @commit="$emit('commit')"
      />
    </div>
  </section>
</template>

<script>
import LsFeedbackText from './LsFeedbackText.vue'

/** One note on the whole sheet for the brand (KP-4572), above the order bar. */
export default {
  name: 'LsSheetNote',
  components: { LsFeedbackText },
  props: {
    brandName: { type: String, required: true },
    note: { type: String, default: '' },
    status: { type: String, default: 'idle' },
    limit: { type: Number, default: 2000 },
  },
}
</script>

<style lang="scss" scoped>
@import './ls-base';

.ls-note {
  margin-top: clamp(48px, 8vw, 96px);

  &__inner {
    max-width: 720px;
    margin: 0 auto;
    padding: 0 $ls-gutter;
  }
}
</style>
